export default __webpack_public_path__ + "static/josep-55e7332b1ce716890df640b770b0be64.png";